/**
 * Global i18n React Hook
 * Provides access to translations based on the global language setting.
 */

import useLanguageStore from '../stores/languageStore';
import { getTranslation, GlobalTranslations } from './locales';
import type { Language } from '../types';

export const useTranslation = (): GlobalTranslations => {
  const { language } = useLanguageStore();
  return getTranslation(language);
};

export const useLanguage = (): [Language, (lang: Language) => void] => {
  const { language, setLanguage } = useLanguageStore();
  return [language, setLanguage];
};
